import { StyledButton } from 'components/button/Button.styles';
import { Row } from 'react-bootstrap';
import styled from 'styled-components';
import theme from 'styles/theme';
import { LeadScreenAndProtectStatus } from 'models/ScreenAndProtect';

export const Container = styled.div`
  padding: 24px 16px;

  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Section = styled.section`
  padding: 16px;
  padding-bottom: 8px;

  h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    margin-bottom: 8px;
  }
`;

const getBookingStatusColor = (status: LeadScreenAndProtectStatus) => {
  const statusColorMap = {
    [LeadScreenAndProtectStatus.APPROVED]: theme.colors.hostfullyGreen,
    [LeadScreenAndProtectStatus.FLAGGED]: theme.colors.hostfullyOrange,
    [LeadScreenAndProtectStatus.REJECTED]: theme.colors.hostfullyOrange,
    // internal uses:
    [LeadScreenAndProtectStatus.PENDING]: theme.colors.hostfullyNeutral,
    [LeadScreenAndProtectStatus.CANCELLED]: theme.colors.hostfullyOrange,
    [LeadScreenAndProtectStatus.FAILED]: theme.colors.hostfullyOrange,
  };

  return statusColorMap[status] || theme.colors.hostfullyNeutral;
};

export const BookingStatus = styled.div<{
  $status: LeadScreenAndProtectStatus;
}>`
  display: flex;
  align-items: center;

  .glyphicon {
    margin-right: 8px;

    color: ${({ $status }) => getBookingStatusColor($status)};
  }
`;

export const StyledRow = styled(Row)`
  padding: 8px 0;

  border-bottom: 1px solid ${theme.colors.gray300};

  span .glyphicon {
    margin-right: 8px;
  }
`;

export const ActionButton = styled(StyledButton)`
  margin-top: 12px;
`;
